import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "refKey", "content"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Tooltip from 'components/Tooltip';
import Text from 'components/Text';
var EasyTooltip = function EasyTooltip(_ref) {
  var children = _ref.children,
    _ref$refKey = _ref.refKey,
    refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
    content = _ref.content,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!content) {
    // Fragments are needed to make TypeScript happy 🤷
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    delay: 250,
    content: content
  }, otherProps), function (_ref2) {
    var ref = _ref2.ref,
      open = _ref2.open,
      close = _ref2.close;
    var tooltipProps = {
      onMouseEnter: open,
      onMouseLeave: close,
      onMouseDown: close,
      onTouchStart: open,
      onTouchEnd: close,
      onFocus: open,
      onBlur: close
    };

    // Text-only children that don't have a wrapper element
    // need to be wrapped in one to attach the tooltip ref
    if (typeof children === 'string') {
      return /*#__PURE__*/React.createElement(Text, _extends({
        ref: ref,
        display: "inline-block"
      }, tooltipProps), children);
    }
    if (/*#__PURE__*/React.isValidElement(children)) {
      return /*#__PURE__*/React.cloneElement(React.Children.only(children), _objectSpread(_defineProperty({}, refKey, ref), tooltipProps));
    }
  });
};
export default EasyTooltip;